import { http } from '../http';

export interface Marca {
  codigo_marca: string;
  descricao: string;
}

export interface MarcaResponse {
  total: number;
  page: number;
  limit: number;
  items: Marca[];
}

export const fetchSgaMarcas = async (
  page: number = 1,
  limit: number = 10,
  busca?: string
): Promise<MarcaResponse> => {
  const termo = busca && busca.trim() ? busca.trim() : undefined;
  const response = await http.get('/sga-marca/listar', {
    params: { page, limit, ...(termo ? { busca: termo } : {}) },
  });

  return response.data;
};
